import BetfairImg from "../assets/images/Betfair.svg";
import DreamImg from "../assets/images/Dream.svg";
import SportradarImg from "../assets/images/Sportradar.svg";

import CricketImg from "../assets/images/sports/cricket.svg";
import TennisImg from "../assets/images/sports/tennis.svg";
import SoccerImg from "../assets/images/sports/soccer.svg";
import IceHockeyImg from "../assets/images/sports/ice_hockey.svg";
import TableTennisImg from "../assets/images/sports/table_tennis.svg";
import KabaddiImg from "../assets/images/sports/kabaddi.svg";
import BasketballImg from "../assets/images/sports/basketball.svg";
import MMAImg from "../assets/images/sports/mma.svg";
import BaseballImg from "../assets/images/sports/baseball.svg";
import BadmintonImg from "../assets/images/sports/badmintion.svg";
import { Provider } from "../models/provider";

export const ProviderImgMap = {
  SportRadar: SportradarImg,
  BetFair: BetfairImg,
  Dream: DreamImg,
};

export const SportImgMap = {
  1: SoccerImg,
  "sr:sport:1": SoccerImg,
  "sr:sport:3": BaseballImg,
  4: CricketImg,
  "sr:sport:21": CricketImg,
  2: TennisImg,
  "sr:sport:5": TennisImg,
  "sr:sport:4": IceHockeyImg,
  "sr:sport:20": TableTennisImg,
  "sr:sport:31": BadmintonImg,
  "sr:sport:138": KabaddiImg,
  "sr:sport:2": BasketballImg,
  "sr:sport:117": MMAImg,
};

export const SportIDNameMap = {
  1: "soccer",
  "sr:sport:1": "soccer",
  4: "cricket",
  "sr:sport:21": "cricket",
  "sr:sport:31": "Badminton",
  2: "tennis",
  "sr:sport:5": "tennis",
  "sr:sport:4": "ice-hockey",
  "sr:sport:20": "table-tennis",
  "sr:sport:138": "kabaddi",
  "sr:sport:2": "Basketball",
  "sr:sport:117": "MMA",
};

export const WSHeaders = {
  token: "Bearer cfbtlatihhvpkyeufamisnwtsfapvurp",
  // Authorization: "123456lsls",
};

export const MarketNamesMap = (marketName: string) => {
  if (["bookmaker", "toss"].includes(marketName.toLowerCase())) {
    return "BOOKMAKER";
  }

  if (marketName.toLowerCase().includes("matchodds")) {
    return "MATCH_ODDS";
  }

  if (marketName.toLowerCase().includes("fancy")) {
    return "FANCY";
  }

  return "MATCH_ODDS";
};

const DefaultDreamPartners = ["st804"];
const DrafultRouteToCricketPartners = ["st8", "st804", "st810101", "st811111"];

export const ProviderSortOrderByPartner = (
  partner: string,
  providers: Provider[]
) => {
  // if (DefaultDreamPartners.includes(partner?.toLowerCase())) {
  return providers
    .sort((a, b) => {
      if (a.providerName < b.providerName) {
        return -1;
      }
      if (a.providerName > b.providerName) {
        return 1;
      }
      return 0;
    })
    .reverse();
  // } else {
  //   return providers.sort((a, b) => {
  //     if (a.providerName < b.providerName) {
  //       return -1;
  //     }
  //     if (a.providerName > b.providerName) {
  //       return 1;
  //     }
  //     return 0;
  //   });
  // }
};

export const DefaultRedirectTosportByPartner = () => {
  return DrafultRouteToCricketPartners.includes(getOperatorId()?.toLowerCase())
    ? "/lobby/SportRadar/4"
    : "/lobby/SportRadar/inplay";
};

export const getOperatorId = () => {
  return sessionStorage.getItem("psOperatorId");
};

export const EmptyMatchOddsResposne = () => {
  return [
    {
      marketId: "",
      marketName: "",
      marketType: "",
      status: "",
      runners: [
        {
          runnerId: "",
          runnerName: "",
          status: "",
          layPrices: [
            { price: 0, size: 0 },
            { price: 0, size: 0 },
            { price: 0, size: 0 },
          ],
          backPrices: [
            { price: 0, size: 0 },
            { price: 0, size: 0 },
            { price: 0, size: 0 },
          ],
        },
        {
          runnerId: "",
          runnerName: "",
          status: "",
          layPrices: [
            { price: 0, size: 0 },
            { price: 0, size: 0 },
            { price: 0, size: 0 },
          ],
          backPrices: [
            { price: 0, size: 0 },
            { price: 0, size: 0 },
            { price: 0, size: 0 },
          ],
        },
        {
          runnerId: "",
          runnerName: "",
          status: "",
          layPrices: [
            { price: 0, size: 0 },
            { price: 0, size: 0 },
            { price: 0, size: 0 },
          ],
          backPrices: [
            { price: 0, size: 0 },
            { price: 0, size: 0 },
            { price: 0, size: 0 },
          ],
        },
      ],
      limits: {
        minBetValue: 0,
        maxBetValue: 0,
        oddsLimit: 0,
        currency: "",
      },
    },
  ];
};

export const marketNameMap = {
  "Bookmaker 0%Comm": "Bookmaker Odds",
  TOSS: "TOSS",
};

export const disabledStatus = ["suspended", "closed", "suspended-manually"];
